// Services Configuration
export const SERVICES_CONFIG = {
  // Main toggle for services functionality
  enableServices: true,
  
  // Services display settings
  display: {
    showInNavigation: true,     // Show Services link in header navigation
    showServicesPage: true,     // Show the full services page
    showServiceCards: true,     // Show individual service cards
    showPricing: true,         // Show pricing information
    showAdditionalInfo: true    // Show "Why Choose Our Treatments" section
  },
  
  // Alternative content when services are disabled
  alternative: {
    showMessage: true,
    message: "Our services information is currently being updated. Please contact us for details.",
    redirectToContact: false
  }
};

// Helper function to check if services are enabled
export const isServicesEnabled = () => {
  return SERVICES_CONFIG.enableServices;
};

// Helper function to check if services should show in navigation
export const shouldShowServicesInNav = () => {
  return SERVICES_CONFIG.enableServices && SERVICES_CONFIG.display.showInNavigation;
};

// Helper function to check if services page should be accessible
export const isServicesPageEnabled = () => {
  return SERVICES_CONFIG.enableServices && SERVICES_CONFIG.display.showServicesPage;
};

// Helper function to check if specific service features should show
export const isServiceFeatureEnabled = (feature) => {
  if (!SERVICES_CONFIG.enableServices) return false;
  return SERVICES_CONFIG.display[feature] || false;
};

// Helper function to get alternative message when services are disabled
export const getServicesAlternativeMessage = () => {
  return SERVICES_CONFIG.alternative;
};
